import React, { useState } from "react";
import { Icon } from "react-icons-kit";
import { iosArrowDown } from "react-icons-kit/ionicons/iosArrowDown";
import { iosArrowForward } from "react-icons-kit/ionicons/iosArrowForward";
import AssetCard from "./AssetCard";
import { getStatusColor, getStatusBGColor, getStatusDisplayText, STATUS_TEXT_COLORS, STATUS_BACKGROUND_COLORS } from "../statusColors";
import { square } from "react-icons-kit/fa/square";
const InspectionPlanCard = ({ plan, planSummary }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!plan) return null;

  const children = plan.children || [];
  const assetCount = children.length;

  return (
    <div
      className="inspection-plan-card"
      style={{
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
        padding: "15px",
        marginBottom: "24px",
      }}
    >
      {/* Main Plan Header */}
      <div
        // onClick={() => setIsExpanded(!isExpanded)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          cursor: "pointer",
          paddingBottom: "15px",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", flex: 1 }}>
          <Icon icon={square} size={24} style={{ marginTop: "-1px", flexShrink: 0, color: getStatusColor(plan.status) }} />
          <div>
            <h3 style={{ margin: "0", fontSize: "18px", fontWeight: "600", color: "#333" }}>{plan.title}</h3>
            <p style={{ margin: "6px 0 0 0", color: "#666", fontSize: "13px" }}>{plan.locationName && <span>{plan.locationName}</span>}</p>
          </div>
        </div>

        <div style={{ display: "flex", gap: "12px", alignItems: "center", flexShrink: 0 }}>
          {/* Summary chips */}
          {/* <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" }}>
            {planSummary && planSummary.overdue > 0 && (
              <div
                style={{
                  padding: "4px 10px",
                  backgroundColor: STATUS_BACKGROUND_COLORS.overdue,
                  color: STATUS_TEXT_COLORS.overdue,
                  borderRadius: "4px",
                  fontSize: "11px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {planSummary.overdue} Overdue
              </div>
            )}
            {planSummary && planSummary.expiring > 0 && (
              <div
                style={{
                  padding: "4px 10px",
                  backgroundColor: STATUS_BACKGROUND_COLORS.expiring,
                  color: STATUS_TEXT_COLORS.expiring,
                  borderRadius: "4px",
                  fontSize: "11px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {planSummary.expiring} Expiring
              </div>
            )}
            {planSummary && planSummary.due > 0 && (
              <div
                style={{
                  padding: "4px 10px",
                  backgroundColor: STATUS_BACKGROUND_COLORS.due,
                  color: STATUS_TEXT_COLORS.due,
                  borderRadius: "4px",
                  fontSize: "11px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {planSummary.due} Due
              </div>
            )}
            {planSummary && planSummary.upcoming > 0 && (
              <div
                style={{
                  padding: "4px 10px",
                  backgroundColor: STATUS_BACKGROUND_COLORS.upcoming,
                  color: STATUS_TEXT_COLORS.upcoming,
                  borderRadius: "4px",
                  fontSize: "11px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {planSummary.upcoming} Upcoming
              </div>
            )}
          </div> */}

          {/* Status badge */}
          <div
            style={{
              padding: "6px 12px",
              borderRadius: "4px",
              backgroundColor: getStatusBGColor(plan.status),
              color: getStatusColor(plan.status),
              fontWeight: "600",
              fontSize: "11px",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            {getStatusDisplayText(plan.status)}
          </div>
        </div>
      </div>

      {/* Asset count indicator */}
      <div
        style={{
          fontSize: "12px",
          color: "#666",
          paddingLeft: "36px",
          paddingBottom: "12px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        {assetCount} asset{assetCount !== 1 ? "s" : ""} in this plan
      </div>

      {/* Expandable Assets Section */}
      {isExpanded && children.length > 0 && (
        <div
          style={{
            marginTop: "12px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          {children.map((asset) => {
            return asset.assetType === "Location Identifier" ? null : <AssetCard key={asset.id} asset={asset} isNestedInPlan={true} />;
          })}
        </div>
      )}

      {isExpanded && children.length === 0 && (
        <div style={{ padding: "16px", textAlign: "center", color: "#999", fontSize: "14px" }}>No assets in this plan</div>
      )}
    </div>
  );
};

export default InspectionPlanCard;



// WEBPACK FOOTER //
// ./src/components/InspectionSchedule/components/InspectionPlanCard.jsx